var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documents-container"},[_c('document-list',{attrs:{"idType":"claim","id":_vm.claim.claim_id,"perPage":"8","mode":"list"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }